import axios from "axios";
import { staticAdapter, STATIC_MODE } from "./staticAdapter";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// When STATIC_MODE is on (Simply.com build), the app has no FastAPI backend:
// GETs are served from /public/data/*.json and Contact form → /api/contact.php.
export const api = axios.create({
  baseURL: STATIC_MODE ? "" : API,
  withCredentials: !STATIC_MODE,
  headers: { "Content-Type": "application/json" },
  ...(STATIC_MODE ? { adapter: staticAdapter } : {}),
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
